// extracted by mini-css-extract-plugin
module.exports = {"new-table":"FinalReportClinicalTable_new-table__3c5Kz"};